export const receiptsOptions = [
  { value: 1, label: 'Draft' },
  { value: 2, label: 'Posted' },
  { value: 3, label: 'Canceled' },
]
